import { useCallback } from 'react';
import { openBrowserAsync } from 'expo-web-browser';

import { OrgLinks } from '../../../../OrgLinksFooter/OrgLinksFooter.constants';

export const useAccountLinks = () => {
  const handleTermsLink = useCallback(() => {
    void openBrowserAsync(OrgLinks.terms);
  }, []);

  const handlePrivacyLink = useCallback(() => {
    void openBrowserAsync(OrgLinks.privacy);
  }, []);

  const handlePersonalInfoLink = useCallback(() => {
    void openBrowserAsync(OrgLinks.personal);
  }, []);

  return {
    handleTermsLink,
    handlePrivacyLink,
    handlePersonalInfoLink,
  };
};
